import numeralFormatter, { NumeralFormats } from './numeralFormatter';

const currencyCellFormatter = ({ value }) =>
  numeralFormatter({ value, format: NumeralFormats.NUMBER_WITHOUT_DECIMALS });

export default currencyCellFormatter;
